import { PaletteOptions } from '@mui/material/styles';

/**
 * Light theme color palette for Yugen Frontend
 * Inverted from dark theme while preserving luxury gold accents
 */
export const lightPalette: PaletteOptions = {
  mode: 'light',

  // Primary: Luxury Gold (darker for light theme)
  primary: {
    main: '#b8941f',      // Darker gold for better contrast
    light: '#d4af37',     // Medium gold for hover states
    dark: '#9a7a1a',      // Deep gold for active states
    contrastText: '#ffffff',
  },

  // Secondary: Bronze (preserved from dark theme)
  secondary: {
    main: '#8b7355',      // Warm bronze
    light: '#a89176',     // Light bronze
    dark: '#6d5a42',      // Deep bronze
    contrastText: '#0d0d0d',
  },

  // Background colors (inverted)
  background: {
    default: '#f5f5f5',   // Light gray background
    paper: '#ffffff',     // Pure white for cards/surfaces
  },

  // Text colors (inverted)
  text: {
    primary: '#0d0d0d',   // Deep black for primary text
    secondary: '#4a4a4a', // Dark gray for secondary text
    disabled: '#9e9e9e',  // Medium gray for disabled text
  },

  // Semantic colors (same as dark theme)
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#ffffff',
  },

  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#000000',
  },

  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#ffffff',
  },

  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#ffffff',
  },

  // Divider color
  divider: 'rgba(212, 175, 55, 0.12)', // Gold with low opacity
};
